import React from 'react';
import Select from 'react-select';
import { defaultDisplay, defaultOptionValue, getFilterFn } from './resourcePickerHelper';

const KovResourcePicker = (
  {
    value,
    defaultValue,
    localData,
    display,
    filter,
    placeholder = '',
    className,
    disabled = false,
    disableSearch = false,
    multiple = false,
    clearable = true,
    optionValue,
    optionTemplate,
    portal,
    onChange,
    style = {},
    components = {},
    menuPlacement = 'auto',
    menuShouldScrollIntoView = true,
  },
  ref
) => {
  const displayFn = typeof display === 'string' ? defaultDisplay(display) : display;
  const getOptionValueFn = optionValue ?? defaultOptionValue;
  const filterFn = getFilterFn({ filter });
  const noOptionsMessage = ({ inputValue }) =>
    inputValue ? `Geen resultaten gevonden.` : placeholder;

  const customStyle = {
    control: (provided) => ({ ...provided, borderRadius: 0 }),
    menu: (provided) => ({ ...provided, borderRadius: 0 }),
    menuPortal: (provided) => ({ ...provided, zIndex: portal ? 9999 : 1 }),
    ...style,
  };

  return (
    <Select
      ref={ref}
      value={value}
      defaultValue={defaultValue}
      placeholder={placeholder}
      className={className}
      isSearchable={!disableSearch}
      isMulti={multiple}
      isClearable={clearable}
      isDisabled={disabled}
      options={localData}
      getOptionLabel={displayFn}
      getOptionValue={getOptionValueFn}
      filterOption={filterFn}
      formatOptionLabel={optionTemplate}
      styles={customStyle}
      menuPortalTarget={portal ? document.querySelector(portal) : null}
      onChange={onChange}
      components={components}
      menuPlacement={menuPlacement}
      menuShouldScrollIntoView={menuShouldScrollIntoView}
      noOptionsMessage={noOptionsMessage}
    ></Select>
  );
};

export default React.forwardRef(KovResourcePicker);
